import axios from "axios";
import Response from "../../models/response";
import config from "../config";
import { api } from "../httpClient";

export const axiosPrivate = api;

export async function createProj(project) {
  let createProject = axios
    .post(
      `${config.base_url}/project/create-project`,
      project
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      console.log(res);
      //return res.json();
      //  return res.status === 200
      // ?
      return new Response(res.status, "Project created!", res.data.data);
      /// : new Response(res.status, "Creation failed!", res.data);
    })
    .catch((err) => {
      err = err.response;

      return new Response(err.status, err.data.message);
    });
  return createProject;
}

export async function getProjects() {
  let allProjects = axios
    .get(
      `${config.base_url}/project/all`
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data.data
          )
        : new Response(res.status, "Error with fetching projects!");
    })
    .catch((err) => {
      err = err.response;
      return "";
      //  return new Response(err.status, err.data.message);
    });
  return allProjects;
}

export async function getProject(id) {
  let allProjects = axios
    .get(
      `${config.base_url}/project/one?id=${id}`
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    ) //JSON.stringify(id) .post(`${config.base_url}/project/one`, id, appJsonContentTypeHeader(localStorage.getItem("jwt")))
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data.data
          )
        : new Response(res.status, "Error with fetching project!");
    })
    .catch((err) => {
      console.log(err);
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return allProjects;
}
export async function getProjectByAdmin(id) {
  let allProjects = axios
    .get(
      `${config.base_url}/project/oneByAdmin?projectId=${id}`
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    ) //JSON.stringify(id) .post(`${config.base_url}/project/one`, id, appJsonContentTypeHeader(localStorage.getItem("jwt")))
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data.data
          )
        : new Response(res.status, "Error with fetching project!");
    })
    .catch((err) => {
      console.log(err);
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return allProjects;
}
export async function getProjectItemsByAdmin(id) {
  let allProjects = axios
    .get(
      `${config.base_url}/project/itemsByAdmin?projectId=${id}`
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    ) //JSON.stringify(id) .post(`${config.base_url}/project/one`, id, appJsonContentTypeHeader(localStorage.getItem("jwt")))
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data.data
          )
        : new Response(res.status, "Error with fetching project!");
    })
    .catch((err) => {
      console.log(err);
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return allProjects;
}

export async function deleteProject(id) {
  let deleteProj = axios
    .delete(
      `${config.base_url}/project/delete?id=${id}`
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Project deleted!", res.data.data)
        : new Response(res.status, "Failed to delete!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return deleteProj;
}

export async function editProject(project) {
  let editProj = axios
    .put(
      `${config.base_url}/project/edit`,
      project
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Project modified!", res.data.data)
        : new Response(res.status, "The project has not been modified!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return editProj;
}

export async function projectItem(project) {
  let createProjectItem = axios
    .post(
      `${config.base_url}/project/item/configurator`,
      project
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 201
        ? new Response(res.status, "Project item created!", res.data.data)
        : new Response(res.status, "Creation failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return createProjectItem;
}
export async function createProjectItemBlob(project) {
  let createProjectItem = axios
    .post(
      `${config.base_url}/project/item/calculate`,
      project
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 201
        ? new Response(res.status, "Project item created!", res.data.data)
        : new Response(res.status, "Creation failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return createProjectItem;
}

export async function getProjectsItem(id) {
  let projectsItem = axios
    .get(
      `${config.base_url}/project/items?id=${id}`
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data.data
          )
        : new Response(res.status, "Error with fetching positions!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return projectsItem;
}

export async function getProjectItemHydra(id) {
  let projectItem = axios
    .get(
      `${config.base_url}/project/items/hydra/all?projectId=${id}` //,appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      const data = Array.isArray(res.data?.data) ? res.data.data : [];
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            data
          )
        : new Response(res.status, "Error with fetching positions!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return projectItem;
}

export async function getProjectItemHydraSingle(id) {
  let projectItem = axios
    .get(`${config.base_url}/project/items/hydra/one?id=${id}`)
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data.data
          )
        : new Response(res.status, "Error with fetching position!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return projectItem;
}

export async function getCustomSummerData(userInput) {
  let allProjects = axios
    .post(
      `${config.base_url}/project/item/customSummer`,
      userInput
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return allProjects;
}

export async function getCustomWinterData(userInput) {
  let allProjects = axios
    .post(
      `${config.base_url}/project/item/customWinter`,
      userInput
      //   appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return allProjects;
}

export async function getRevisions(id) {
  let allProjects = axios
    .get(
      `${config.base_url}/project/items/revision/all?id=${id}`
      //id,
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data
          )
        : new Response(res.status, "Error with fetching revisions!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return allProjects;
}

export async function deleteProjectItem(id) {
  let deleteProj = axios
    .delete(
      `${config.base_url}/project/item/delete?id=${id}`
      //    appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Project item deleted!", res.data.data)
        : new Response(res.status, "Failed to delete!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return deleteProj;
}

export async function getProjectItem(id) {
  let activePosition = axios
    .get(
      `${config.base_url}/project/items/one?id=${id}`
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data.data
          )
        : new Response(res.status, "Error with fetching position!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });

  return activePosition;
}
export async function getProjectItemByAdmin(id) {
  let activePosition = axios
    .get(`${config.base_url}/project/oneItemByAdmin?itemId=${id}`)
    .then((res) => {
      return res.status === 200
        ? new Response(
            res.status,
            "Your request has been successful!",
            res.data.data
          )
        : new Response(res.status, "Error with fetching position!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });

  return activePosition;
}

export async function editProjectItem(projectItemData) {
  let editProjectItem = axios
    .put(
      `${config.base_url}/project/item/configurator`,
      projectItemData
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Project item modified!", res.data.data)
        : new Response(res.status, "The project item has not been modified!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return editProjectItem;
}
export async function activateRevision(id) {
  let activeProjectItem = axios
    .get(
      `${config.base_url}/project/item/revision/activate?id=${id}`

      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Revision is activated!", res.data.data)
        : new Response(res.status, "Revision has not been activated!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });

  return activeProjectItem;
}

export async function getDocument(id, revNum) {
  let documentation = axios
    .get(
      `${config.base_url}/project/items/document/view?id=${id}&revNum=${revNum}`,
      {
        responseType: "arraybuffer",
      }
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Documentation sent!", res.data)
        : new Response(res.status, "Error with fetching documentation!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });

  return documentation;
}

export async function getModel(id, revNum) {
  let model = axios
    .get(
      `${config.base_url}/project/items/document/model?id=${id}&revNum=${revNum}`
      //appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Model link created!", res.data)
        : new Response(res.status, "Error with model link");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });

  return model;
}

export async function getAirFlowCalculation(
  airflowSupply,
  airflowReturn,
  ahuType
) {
  let unitTypes = axios
    .get(
      `${config.base_url}/project/items/airflow/calculator?airFlowSup=${airflowSupply}&airFlowEha=${airflowReturn}&ahuType=${ahuType}`
      //appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Unit types returned!", res.data)
        : new Response(res.status, "Error with fetching unit types!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });

  return unitTypes;
}

export async function getCalculations(id, revNum) {
  let technicalCardData = axios
    .get(
      `${config.base_url}/project/items/calculations?id=${id}&revNum=${revNum}`
      //id,
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return technicalCardData;
}

export async function getCalculationsByAdmin(id, revNum) {
  let technicalCardData = axios
    .get(
      `${config.base_url}/project/items/calculationsByAdmin?id=${id}&revNum=${revNum}`
      //id,
      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return technicalCardData;
}

export async function getTechCardDataForMollier(id, revNum) {
  let processPoints = axios
    .get(
      `${config.base_url}/project/items/calculations/mollier?id=${id}&revNum=${revNum}`
      //id,
      //appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return processPoints;
}

export async function getDashboardData() {
  let projectDashboardData = axios
    .get(
      `${config.base_url}/project/dashboard`
      //id,
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return projectDashboardData;
}

export async function getTechCardStatus(id, revNum) {
  let techCardStatus = axios
    .get(
      `${config.base_url}/project/items/techCardStatus?id=${id}&revNum=${revNum}`

      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return techCardStatus;
}

export async function getProjectLocationConditions(lat, lng) {
  let projectLocationConditions = axios
    .get(
      `${config.base_url}/project/location-params/conditions?lat=${lat}&lng=${lng}`

      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return projectLocationConditions;
}

export async function getAirQualityCurrent(lat, lng) {
  let airQualityCurrent = axios
    .get(
      `${config.base_url}/project/location-params/aqiCurrent?lat=${lat}&lng=${lng}`

      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return airQualityCurrent;
}

export async function getAirQualityYearly(lat, lng) {
  let airQualityYearly = axios
    .get(
      `${config.base_url}/project/location-params/aqiYearly?lat=${lat}&lng=${lng}`

      //appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return airQualityYearly;
}

export async function getElectricityCostHome(countryShortCode) {
  let electricityCostHome = axios
    .get(
      `${config.base_url}/project/location-params/electricity?countryShortCode=${countryShortCode}`

      //  appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return electricityCostHome;
}

export async function getAqiAverage(lat, lng, particle, year) {
  let aqiAverage = axios
    .get(
      `${config.base_url}/project/aqi-average/values?lat=${lat}&lng=${lng}&particle=${particle}&year=${year}`

      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return aqiAverage;
}
export async function getHydraTypes(maxRequiredAir) {
  let hydraTypes = axios
    .get(
      `${config.base_url}/project/item/hydra/getTypes?maxRequiredAir=${maxRequiredAir}`

      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return hydraTypes;
}

export async function getDamperData(unitTypeId) {
  let damperData = axios
    .get(
      `${config.base_url}/project/item/damper/getData?unitTypeId=${unitTypeId}`
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return damperData;
}

export async function createHydraItem(hydraProjectItemRequest) {
  let createProject = axios
    .post(
      `${config.base_url}/project/item/hydra/create`,
      hydraProjectItemRequest
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return new Response(
        res.status,
        "Hydra project item created!",
        res.data.data
      );
    })
    .catch((err) => {
      return new Response(err.status, err.data.message);
    });

  return createProject;
}

export async function editHydraItem(hydraProjectItemRequest) {
  let editHydraItem = axios
    .put(
      `${config.base_url}/project/item/hydra/edit`,
      hydraProjectItemRequest
      // appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return new Response(
        res.status,
        "Hydra project item edited!",
        res.data.data
      );
    })
    .catch((err) => {
      return new Response(err.status, err.data.message);
    });

  return editHydraItem;
}

export async function deleteHydraProjectItem(id) {
  let deleteHydraItem = axios
    .delete(`${config.base_url}/project/item/hydra/delete?id=${id}`)
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "Project item deleted!", res.data.data)
        : new Response(res.status, "Failed to delete!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return deleteHydraItem;
}

export async function validateRecAsync(projItem) {
  console.log(projItem);
  let validationRecResult = axios
    .post(
      `https://dllcontroller.azurewebsites.net/api/recVal`,
      //`https://ahuframeless.switzerlandnorth.cloudapp.azure.com/dllcontroller/api/recVal`,
      projItem
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  console.log(validationRecResult);
  return validationRecResult;
}
export async function validateFanAsync(projItem) {
  console.log(projItem);
  let validationFanResult = axios
    .post(
      `https://dllcontroller.azurewebsites.net/api/fanVal`,
      //`https://ahuframeless.switzerlandnorth.cloudapp.azure.com/dllcontroller/api/fanVal`,
      {
        withCredentials: true,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          // Add any other headers you need
        },
      },
      projItem
    )
    .then((res) => {
      console.log(res);
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  console.log(validationFanResult);
  return validationFanResult;
}

export async function getAllProjectsAdmin() {
  let allProjects = axios
    .get(`${config.base_url}/project/allAdmin`)
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return allProjects;
}

export async function getUserProjectByAdmin(userId) {
  let allProjects = axios
    .get(`${config.base_url}/project/getProjectsAdmin?id=${userId}`)
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return allProjects;
}

/*export async function validateProjectItem(projectItem) {
  let validationResult = axios
    .post("https://dllcontroller.azurewebsites.net/api/inputs", projectItem)
    .then((res) => {
    res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Error(res.status, "Failed!");
    }).catch((err) => {
      console.log(err);
      let errRes = err.response;
      let errReq = err.request;
      let errMsg = err.message;

      console.log(errRes);
      console.log(errReq);
      console.log(errMsg);

      return new Error(errRes.status, errRes.data.message);
      return err;
    });
  return validationResult;
}*/

export async function validateProjectItemRec(projectItem) {
  try {
    let validationResult = axios.post(
      "https://dllcontroller.azurewebsites.net/api/recVal",
      projectItem
    );
    //Kreiram  novi promise koji ce se izvrsiti posle 10s pod pretpostavkom da ako postoji greska
    //server vraca gresku za manje od 10s
    const timeoutPromise = new Promise((resolve) => {
      setTimeout(() => {
        resolve({ timeout: true });
      }, 3000);
    });
    //Vraca rezultat prvog uspesnog promisa
    const result = await Promise.race([validationResult, timeoutPromise]);
    if (result.timeout) {
      // Prosledjujem korisnika posle 10s na filtere
      return true;
    } else {
      //vraca json sa kalkulacijama
      return validationResult.data;
    }
  } catch (error) {
    let userMsg = "";
    if (error.response) {
      //TPS ili rekuperator su vratili gresku koju cemo prikazati na frontu
      userMsg = error.response.data;
    } else if (error.request) {
      //Server nije odgovorio
      console.log("No response received:", error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error:", error.message);
    }
    throw new Error(userMsg);
  }
}
export async function validateProjectItemFan(projectItem) {
  try {
    let validationResult = await axios.post(
      "https://dllcontroller.azurewebsites.net/api/fanVal",
      projectItem
    );
    return validationResult.data;
  } catch (error) {
    let userMsg = "";
    if (error.response) {
      //Fan dll vraca gresku koju zelimo da prikazemo korisniku
      userMsg = error.response.data;
    } else if (error.request) {
      console.log("No response received:", error.request);
    } else {
      console.log("Error:", error.message);
    }
    throw new Error(userMsg);
  }
}

/*export async function getElevation(lat, lng) {
  console.log(lat, lng);
  fetch(
    `https://maps.googleapis.com/maps/api/elevation/json?locations=39.7391536%2C-104.9847034&key=AIzaSyCSQ1dLeEIgi-ZoltDc3lBau9CDsVh028s`,
    { method: "GET", mode: "no-cors" }
  ).then((placeDetails) => {
    console.log(placeDetails);
    return placeDetails;
  });
}
  axios
    .get(
      `https://maps.googleapis.com/maps/api/elevation/json?locations=39.7391536%2C-104.9847034&key=AIzaSyCSQ1dLeEIgi-ZoltDc3lBau9CDsVh028s`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      console.log(response.data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

/* try {
    let elevationAPI = await axios.get(
      `https://maps.googleapis.com/maps/api/elevation/json?locations=${lat}%2C${lng}&key=AIzaSyCSQ1dLeEIgi-ZoltDc3lBau9CDsVh028s`,
      { mode: "no-cors" }
    );
    return elevationAPI;
  } */

export async function CheckBlobExist(guid) {
  var fileName = `${guid}.json`;
  let odg;
  try {
    odg = await axios({
      method: "GET",
      url: `https://framelessdocumentation.blob.core.windows.net/frameless-docs/Frameless4.0/${fileName}`,
      mode: "no-cors",
    });
    console.log(odg);
  } catch (err) {
    throw new Error(err);
  }
  return odg;
  /* console.log(fileName);
  let resi = axios
    .get(
      "https://framelessdocumentation.blob.core.windows.net/frameless-docs/Frameless4.0/",
      fileName
    )
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
  return resi;*/
}
